var Request = /** @class */ (function () {
    function Request() {
    }
    Request.prototype.get = function (url) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.open('GET', url);
            xhr.timeout = 1000;
            xhr.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    resolve({
                        status: this.status,
                        body: this.response,
                    });
                }
                else {
                    reject({
                        status: this.status,
                    });
                }
            };
            xhr.ontimeout = function () {
                reject({
                    status: 502,
                });
            };
            xhr.send();
        });
    };
    Request.prototype.post = function (url, data) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.open('POST', url, true);
            if (xhr.setRequestHeader) {
                xhr.setRequestHeader('Content-Type', 'application/json');
            }
            xhr.send(JSON.stringify(data));
            xhr.timeout = 1000;
            xhr.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    resolve({
                        status: this.status,
                        body: this.response,
                    });
                }
                else {
                    reject({
                        status: this.status,
                    });
                }
            };
            xhr.ontimeout = function () {
                reject({
                    status: 502,
                });
            };
        });
    };
    return Request;
}());
export default new Request();
